<style lang="scss" scoped>
.equ {
  position: absolute;
  width: 416px;
  height: 198px;
  left: 107px;
  top: 583px;
  margin-top: 20px;
  .smoke{
    margin-top: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-evenly;
    text-align: center;
    .num{
      height: 92px;
      font-size: 18px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      p:nth-child(2){
        font-family: 'dina';
        font-size: 48px;
      }
      .zc{
        color:rgba(45, 130, 255, 1);
      }
      .gz{
        color: #f1802f;
      }
    }
  }
}
</style>

<template>
  <div class="equ">
    <custom-plane title="烟感"
      :iconImg="require('@/assets/compImg/fireIcon/smoke.png')">
      <div class="smoke">
        <div class="num">
          <p>正常数量</p>
          <p class="zc">{{number1}}</p>
        </div>
        <div class="num">
          <p>故障数量</p>
          <p class="gz">{{number2}}</p>
        </div>
      </div>
    </custom-plane>
  </div>
</template>

<script>
  export default {
    props:{
      number1:Number,
      number2:Number
    }
  }
  </script>
